import { AppShell } from '../AppShell/AppShell';

export const Layout = ({ children }) => {
  return <AppShell>{children}</AppShell>;
};
